export function getCreditCardTypeFromId(id) {
  switch (id) {
    case 5:
      return "Master Card";
    case 6:
      return "Visa";
    case 7:
      return "American Express";
    case 8:
      return "Discover";
    default:
      return "Unknown";
  }
}
